import { ThemeProvider } from '@mui/system'
import React, { StrictMode, Suspense } from 'react'
import ReactDOM from 'react-dom/client'

import 'shaka-player/dist/controls.css'
import 'shaka-player-ui-controls/dist/main.css'
import './app/styles/app-style.css'
import '@/shared/styles/player-style.css'
import '@/shared/styles/vod/vodRow.css'
import '@/shared/styles/vod/vodItem.css'
import './.d'
import './shared/i18n/i18n'
import '@/app/theme/themeTypes'

import App from './app/App'
import theme from '@/app/theme/theme'

// fonts for MUI
import '@fontsource/roboto/300.css'
import '@fontsource/roboto/400.css'
import '@fontsource/roboto/500.css'
import '@fontsource/roboto/700.css'
import { BrowserRouter as Router } from 'react-router-dom'
import HomeContentSkeleton from './features/VOD/components/skeletons/HomeContentSckeleton'

const rootElement = document.getElementById('root')
const root = ReactDOM.createRoot(rootElement as HTMLElement)

root.render(
    <StrictMode>
        <ThemeProvider theme={theme}>
            <Suspense fallback={<HomeContentSkeleton />}>
                <Router>
                    <App />
                </Router>
            </Suspense>
        </ThemeProvider>
    </StrictMode>
)
